export function addNutrient(rowCount) {
    const measurements = [];
    for (let m = 0; m < rowCount; m++) {
        measurements.push("");
    }

    return {
        nutrient: {
            value: Math.round(new Date().getTime() / 1000),
            text: "",
        },
        minMax: "",
        measurements,
        description: "",
        noteMark: "",
    };
}

export const DEFAULT_GUARANTEED_ANALYSIS = {
    header: "",
    servingSize: "",
    servingsPerContainer: "",
    calorieContent: "",
    aafcoStatement: "",
    analysis: {},
    footnotes: {},
    ingredients: {},
    healthClaims: { items: [] },
    allergens: {
        contains: [],
        mayContain: [],
        doesNotContain: [],
    },
};
